const isoTimeToLocaleTimeString = (value) => {
  if (!value.endsWith("Z")) {
    value = value + "Z";
  }
  const d = new Date(value);
  return `${d.toLocaleDateString()} ${d.toLocaleTimeString()}`;
};

export default isoTimeToLocaleTimeString;
